export default {
  setAuthState(state, { initialized, isAuthenticated, candidateId }) {
    state.authInitialized = initialized;
    state.isAuthenticated = isAuthenticated;
    state.candidateId = candidateId;
  },

  setApplicationsLoading(state, loading) {
    state.applicationsLoading = loading;
  },

  setApplications(state, applications) {
    state.applications = applications;
    state.applicationsLoaded = true;
    state.loadFailed = false;
  },

  setApplicationStatus(state, { applicationId, statusId }) {
    const application = state.applications.find(
      (app) => app.applicationId === applicationId
    );

    if (application) {
      application.statusId = statusId;
    }
  },

  setMustAcceptInvitations(state, mustAcceptInvitations) {
    state.mustAcceptInvitations = mustAcceptInvitations;
  },

  setInterviewStatus(
    state,
    { applicationId, interviewId, invitationStatusId }
  ) {
    const application = state.applications.find(
      (app) => app.applicationId === applicationId
    );

    if (!application || !application.interviews) {
      return;
    }

    const interview = application.interviews.find(
      (item) => item.id === interviewId
    );

    if (interview) {
      interview.invitationStatusId = invitationStatusId;
    }
  },

  setLoadFailed(state, failed) {
    state.loadFailed = failed;
  },

  setProfile(state, profile) {
    state.profile = profile;
  },

  setProfileDocuments(state, documents) {
    if (state.profile) {
      state.profile = { ...state.profile, documents };
    }
  },

  setProfileLoading(state, loading) {
    state.profileLoading = loading;
  },

  setProfileSaving(state, saving) {
    state.profileSaving = saving;
  },

  setProfileError(state, error) {
    state.profileError = error;
  }
};
